import { PathParameters } from "@faire/web-api/routes/brand/brandToken";
import { match as matchBrandRoute } from "@faire/web-api/routes/brand/brandToken/match";
import { match } from "react-router-dom";

export const isBrandPageRoute = (
  pathname: string,
  search: string
): match<PathParameters> | null => {
  if (!pathname.endsWith("/")) {
    pathname += "/";
  }
  return matchBrandRoute(`${pathname}${search}`);
};
